import {
  Box,
  MenuItem,
  Select,
  Stack,
  TablePagination,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { productRegistryPageSizes } from '@/config/productRegistry';

interface DataTablePaginationProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  labelKey?: string;
}

export function DataTablePagination({
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
  labelKey = 'productRegistry.productRegistryPaginationLabel',
}: DataTablePaginationProps) {
  const { t } = useTranslation('entity-portal');

  const from = total === 0 ? 0 : page * pageSize + 1;
  const to = Math.min(total, (page + 1) * pageSize);

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'stretch', sm: 'center' }}
      justifyContent="space-between"
      spacing={1.5}
      sx={{ px: 2, py: 1.5, borderTop: 1, borderColor: 'divider' }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="body2" color="text.secondary">
          {t('productRegistry.productRegistryRowsPerPage')}
        </Typography>
        <Select
          size="small"
          value={pageSize}
          onChange={(event) => onPageSizeChange(Number(event.target.value))}
          aria-label={t('productRegistry.productRegistryRowsPerPage')}
          sx={{ minWidth: 72 }}
        >
          {productRegistryPageSizes.map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </Select>
      </Stack>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {t(labelKey, { from, to, total })}
        </Typography>
        <TablePagination
          component="div"
          count={total}
          page={page}
          onPageChange={(_event, nextPage) => onPageChange(nextPage)}
          rowsPerPage={pageSize}
          onRowsPerPageChange={() => undefined}
          rowsPerPageOptions={[]}
          labelDisplayedRows={() => ''}
          sx={{
            p: 0,
            border: 0,
            '& .MuiTablePagination-toolbar': { p: 0, minHeight: 32 },
            '& .MuiTablePagination-spacer, & .MuiTablePagination-selectLabel, & .MuiTablePagination-select, & .MuiTablePagination-displayedRows':
              { display: 'none' },
          }}
        />
      </Box>
    </Stack>
  );
}
